const analysis = {
  icon: 'PieChartIcon',
  title: 'Analysis',
  subtitle: 'Choose what you would like to analyse.',
}

export default analysis
